<template>
    <div id="vendors-items-container">
        <div class="row">
            <div class="col-12">
                <h4 class="page-title text-truncate">{{$t('therapyCatListing.Title')}}</h4>
                <div class="row">
                    <div class="col-sm-12 col-md-3" v-if="hasPermissionAdd()">                      
                        <MdButton
                            v-bind:Label="$t('therapyCatListing.AddTherapyCategory')" 
                            v-bind:ClassProp="'btn btn-primary my-3 btn-block btn-login'"
                            v-bind:IconClass="'ti-plus pr-1'"
                            v-on:click="AddTherapyCat"
                            v-bind:Name="'btn_add_vendor'">
                        </MdButton>
                    </div>

                    <div  v-bind:class="hasPermissionAdd() ? 'col-sm-12 col-md-9 mb-4':'col-sm-12 col-md-12 mb-4'">
                        <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                            <div class="input-group" dir="ltr">
                                <input 
                                    type="text" 
                                    class="form-control"
                                    :dir="dirInput"
                                    v-model="parameter.SearchCriteria"   
                                    @keyup.enter="SearchTherapyCategories"                            
                                >
                                <div class="input-group-append">
                                    <div class="input-group-append">
                                        <MdButton 
                                            v-bind:Name="'btnsearchinput'"
                                            v-bind:VariantProp="'btn btn-sm search-attached'"
                                            v-bind:IconClass="'mdi mdi-magnify'"
                                            v-on:click="SearchTherapyCategories">
                                        </MdButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 mt-2">
                <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
                <div class="row">
                    <div class="col-md-12">
                        <MdTable 
                            v-bind:fields="fields"
                            v-bind:items="items"
                            v-bind:totalRows="totalRows"
                            v-bind:isReadOnly="isReadOnly"
                            v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                            v-bind:currentPage="currentPage"
                            v-bind:perPage="perPage"
                            v-bind:pageOptions="pageOptions"
                            :editIconEvent="EditTherapyCat"
                            v-bind:VisibleEditIcon="hasPermissionEdit()"
                            :deleteIconEvent="RemoveTherapyCat"
                            v-bind:VisibleDeleteIcon="hasPermissionDelete()"
                            :onRowSelected="onRowSelected"
                            :onFiltered="onFiltered"
                            :pageChanged="pageChanged"
                            :perPageFunction="PerPageFunction">
                        </MdTable>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TherapyCategoriesService from '@/services/therapycategories.service';
import DBFunctions from '@/common/DBFunctions.js'
import ShowMessage from '@/components/messages/ShowMessage.js';
import Permission from '@/common/Permission'

export default {
    name: 'therapyCatListing',
    mixins: [DBFunctions, ShowMessage, Permission],

    data() {
        return {
            OptionsRightMenu:{
                 visible:false,
                ItemsList:[],
                btnvisible:false,
                itemdisabled: false,
                Mode:this.edit_mode,
                favButtonAtion:false 
            }, 
            parameter: {
                SearchCriteria: '',
                PageNumber : 0,
                PageSize: 0 ,
            },
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
            fields: [
                { key: 'name', sortable: true, label: this.$t('Shared.Name'), class: 'text-rigth' },      
                { key: 'code', sortable: true, label: this.$t('Shared.Code'), class: 'text-rigth' },
            ],
            pageOptions: [5, 10, 15 ],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            items: [],
            isReadOnly: false,
            ShowMessageIsEmpty:false,
            Mode:'', 
        }
    },

    methods: {
        AddTherapyCat() {
            this.Mode = "Add";
            this.emitDataforFavorites();  
            this.$emit('onUpdatedMenu', '');  
            this.$router.push({ name: "TherapyCatAdd" })
        },

        async getTherapyCategories() {
            this.parameter.PageNumber = this.currentPage;           
            this.parameter.PageSize = this.perPage;

            await TherapyCategoriesService.getAll(this.parameter)
            .then(response => {
                    if (response.status == '200' && response.data) {
                        this.items = response.data;
                        let headerString = response.headers['x-pagination'];
                        const header = JSON.parse(headerString);
                        this.totalRows = header.TotalCount;
                    }

                    this.showMessageIsEmpty = this.totalRows === 0;
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        EditTherapyCat(row) {
            this.Mode = "Edit";
            this.$router.push({ name: "TherapyCatEdit", params: {id: row.code} });
        },

        RemoveTherapyCat(row) {
            this.$bvModal.msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
					title: this.$tc('Shared.DelRecord'),
					okTitle: this.$t('Shared.TitleDelete'),
					cancelTitle: this.$t('Shared.BtnCancel'),
					footerClass: 'p-2',
					titleClass: 'modal-title modal-type-warning',
                    id:'modal_delete_cat'
				})
                .then(value => {
                    if(value){
                        TherapyCategoriesService.delete(row.code)
                            .then(() => {
                                this.currentPage = 1;
                                this.SearchTherapyCategories();
                            })
                            .catch((error) => {
                                this.showResponseErrorMessage(error);
                            });
                    }
                })
        },

        pageChanged(page) {            
            this.currentPage = page;
            this.getTherapyCategories();
        },

        PerPageFunction(perpage){
            this.perPage = perpage;
            this.currentPage = 1;
            this.getTherapyCategories();
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },

        onRowSelected(items) {    
           this.selected = items;
        },

        SearchTherapyCategories() {
            this.items = [];
            this.currentPage = 1;
            this.parameter.PageNumber = 1;
            this.totalRows = this.items.length;
            this.getTherapyCategories();
        },

    },

    mounted() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch(layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
            break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        this.$nextTick(() => {
            this.getTherapyCategories();
        });
    }
}
</script>